import { Box } from 'braid-design-system';
import type React from 'react';

import * as styles from './headerExtension.css';

export const HeaderExtension = () => (
  <Box className={styles.headerExtension}>&nbsp;</Box>
);
